<template>
  <div v-if="cart.virtualServers.length">
    <StoreInit store="vps-catalog">
      <template #fallback>
        <ShoppingCartSectionSkeleton title="Servere" />
      </template>
      <StoreInit store="vps-addon-catalog">
        <template #fallback>
          <ShoppingCartSectionSkeleton title="Servere" />
        </template>
        <UDashboardCard
          :title="`Servere`"
          :description="`${cart.virtualServers.length} server(e) i handlekurven`"
          :links="[
            {
              label: 'Legg til flere servere',
              color: 'gray',
              to: '/cloud-server',
            },
          ]"
        >
          <ShoppingCartItem
            v-for="item in cart.virtualServers"
            :item-id="item.id!"
          >
            <template #description>
              {{
                getStrippedVpsTemplateName(
                  vpsCatalog.getTemplateBySubscriptionId(
                    item.virtualServer!.subscriptionId!
                  )!
                )
              }}
              <div class="text-xs font-normal">
                {{
                  getVpsSubscriptionDescription(
                    vpsCatalog.getSubscriptionById(
                      item.virtualServer!.subscriptionId!
                    )!
                  )
                }}
                ({{
                  getAgreementPeriodHumanText(
                    vpsCatalog.getSubscriptionById(
                      item.virtualServer?.subscriptionId!
                    )?.agreementPeriodType!
                  )
                }})
              </div>
            </template>

            <template #price>
              <div :class="['flex-row items-center space-x-2 flex']">
                <ServerPriceDisplay
                  :subscription-id="item.virtualServer!.subscriptionId!"
                />
              </div>
            </template>

            <template
              #addons
              v-if="cart.items.filter((i) => i.parentItemId === item.id).length"
            >
              <ShoppingCartServerAddOnItem
                v-for="addon in cart.items.filter(
                  (i) => i.parentItemId === item.id
                )"
                :cart-item-id="addon.id!"
                :add-on-id="addon.addOn?.addOnId!"
              />
            </template>
          </ShoppingCartItem>
        </UDashboardCard>
      </StoreInit>
    </StoreInit>
  </div>
</template>

<script lang="ts" setup>
import { getAgreementPeriodHumanText } from "~/helpers/agreementPeriodHelper";
import {
  getVpsSubscriptionDescription,
  getStrippedVpsTemplateName,
} from "~/helpers/vpsHelpers";
import { useVpsCatalogStore } from "~/stores/catalog/vps-catalog";

const vpsCatalog = useVpsCatalogStore();
const cart = useCartStore();
</script>

<style></style>
